import React, {
  createContext, ReactNode, useContext, useState,
} from "react";

interface CalculatorStoreContextType {
  annualSalary: string,
  partnerSalary: string,
  depositAmount: string,
  regularOutgoings: string,
  mortgageAmount: string,
  mortgageTerm: string,
  mortgageInterestRate: string,
  propertyValue: string,
  locationProperty?: string,
  firstTimeBuyer?: string,
  onlyProperty?: string,
  outstandingMortgageAmount: string,
  currentlyMonthlyPayment: string,
  knownLTVValue: string,
  setAnnualSalary: (data: string) => void,
  setPartnerSalary: (data: string) => void,
  setDepositAmount: (data: string) => void,
  setRegularOutgoings: (data: string) => void,
  setMortgageAmount: (data: string) => void,
  setMortgageTerm: (data: string) => void,
  setMortgageInterestRate: (data: string) => void,
  setPropertyValue: (data: string) => void,
  setLocationProperty: (data: string) => void,
  setFirstTimeBuyer: (data: string) => void,
  setOnlyProperty: (data: string) => void,
  setOutstandingMortgageAmount: (data: string) => void,
  setCurrentlyMonthlyPayment: (data: string) => void,
  setKnownLTVValue: (data: string) => void,
}

const CalculatorStoreContext = createContext<CalculatorStoreContextType | undefined>(undefined);

export const CalculatorStoreProvider = ({ children }: { children: ReactNode | ReactNode[]}) => {
  const [annualSalary, setAnnualSalary] = useState<string>("");
  const [partnerSalary, setPartnerSalary] = useState<string>("");
  const [depositAmount, setDepositAmount] = useState<string>("");
  const [regularOutgoings, setRegularOutgoings] = useState<string>("");
  const [mortgageAmount, setMortgageAmount] = useState<string>("");
  const [mortgageTerm, setMortgageTerm] = useState<string>("");
  const [mortgageInterestRate, setMortgageInterestRate] = useState<string>("");
  const [propertyValue, setPropertyValue] = useState<string>("");
  const [locationProperty, setLocationProperty] = useState<string | undefined>();
  const [firstTimeBuyer, setFirstTimeBuyer] = useState<string | undefined>(undefined);
  const [onlyProperty, setOnlyProperty] = useState<string | undefined>(undefined);
  const [outstandingMortgageAmount, setOutstandingMortgageAmount] = useState<string>("");
  const [currentlyMonthlyPayment, setCurrentlyMonthlyPayment] = useState<string>("");
  const [knownLTVValue, setKnownLTVValue] = useState<string>("");

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value: CalculatorStoreContextType = {
    annualSalary,
    partnerSalary,
    depositAmount,
    regularOutgoings,
    mortgageAmount,
    mortgageTerm,
    mortgageInterestRate,
    propertyValue,
    locationProperty,
    firstTimeBuyer,
    onlyProperty,
    outstandingMortgageAmount,
    currentlyMonthlyPayment,
    knownLTVValue,
    setAnnualSalary,
    setPartnerSalary,
    setDepositAmount,
    setRegularOutgoings,
    setMortgageAmount,
    setMortgageTerm,
    setMortgageInterestRate,
    setPropertyValue,
    setLocationProperty,
    setFirstTimeBuyer,
    setOnlyProperty,
    setOutstandingMortgageAmount,
    setCurrentlyMonthlyPayment,
    setKnownLTVValue
  };

  return (
    <CalculatorStoreContext.Provider value={value}>
      {children}
    </CalculatorStoreContext.Provider>
  );
};

export const useCalculatorStore = (): CalculatorStoreContextType => {
  const context = useContext(CalculatorStoreContext);
  if (context === undefined) {
    throw new Error("Context lost");
  }
  return context;
};
